import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PaymentMethodsListItemWrapper = styled.div`
  margin-top: ${Spacing.S12};
  margin-bottom: ${Spacing.S12};
`

export const DetailsAndSwitchWrapper = styled.div`
  min-width: 0;
`

export const DetailsWrapper = styled.div`
  flex: 1;
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
